import React, { useEffect, useContext, useMemo, useState } from 'react';
import { UserContext } from "../../context/userContext";
import { ListcandidateContext } from "../../context/ListcandidateContext";
import '../../assets/css/candidates_for.css';
import "../../assets/css/admin_users_page.css";
import { useHistory } from "react-router-dom";
import Header from './includes_admin/Header';
import { Filters } from './includes_admin/Filters';
import { TableCandidatesIfa } from './TableCandidatesIfa/TableCandidatesIfa';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { API } from '../../http-common';
import { getCandidatesTitle, listFilter, MAX_EXPORT_RECORDS, ROLE } from "../../helpers/constants";
import { Button } from 'react-bootstrap';
import { HorizontalScroll } from './Scroll/HorizontalScroll';
import { faExclamationCircle, faUsers } from '@fortawesome/free-solid-svg-icons';
import { ExportCsvButton } from './DetailsApplicant/includes-details/ExportCsvButton';

const Admin = () => {
  const { userData } = useContext(UserContext)

  const [errorApi, setErrorApi] = useState('Esperando datos...')

  const [listCandidateData, setListCandidateData] = useState([])
  const [userTypeFilter, setUserTypeFilter] = useState('');

  const filteredCandidateData = useMemo(() => {
    if (userTypeFilter === 'subusers') {
      return listCandidateData.filter(item => Boolean(item.parent_complete_name));
    }
    if (userTypeFilter === 'users') {
      return listCandidateData.filter(item => !item.parent_complete_name);
    }
    return listCandidateData;
  }, [listCandidateData, userTypeFilter]);

  const ProviderListCandidateData = useMemo(
    () => ({ listCandidateData: filteredCandidateData, setListCandidateData }),
    [filteredCandidateData, setListCandidateData]
  );

  const [filterBy, setFilterBy] = useState('');
  const [searchValue, setSearchValue] = useState('');

  const title = useMemo(() => getCandidatesTitle(userData?.business_id), [userData?.business_id]);
  const isFiltering = filterBy !== "" || searchValue !== "" || userTypeFilter !== "";
  const history = useHistory();
  const showAdminUsers = userData?.isAdmin === true;
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);

  const getListProspect = async (currentPage, currentLimit, currentFilter, currentSearch) => {
    setErrorApi("Cargando...");
    setListCandidateData([]);

    const offset = (currentPage - 1) * currentLimit;
    const status = listFilter.find(item => item.name === currentFilter)?.status_id || '';
    const search = currentSearch || '';

    try {
      const response = await API.get(`/prospects/paginatedList?page=${currentPage}&limit=${currentLimit}&offset=${offset}&status=${status}&search=${search}`);
      const data = response.data.data;
      const pagination = response.data.pagination;

      setTotalPages(pagination.totalPages || 1);
      setTotalCount(pagination.count || 0);
      if (data && data.length > 0) {
        setErrorApi("");
        setListCandidateData(data);
      } else {
        setErrorApi("No hay datos...");
      }
    } catch (error) {
      setErrorApi(error.response);
    }
  };

  // Reset filtros si cambia la UDN
  useEffect(() => {
    if (userData?.business_id == null) return;
    setFilterBy("");
    setSearchValue("");
    setPage(1);
  }, [userData?.business_id]);

  // Actualizar al cambiar
  useEffect(() => {
    if (userData?.business_id == null) return;
    getListProspect(page, itemsPerPage, filterBy, searchValue);
  }, [page, itemsPerPage, filterBy, searchValue, userData?.business_id]);

  const handleSelect = (e) => {
    const value = e.target.value;
    const isValid = value === '' || listFilter.some(item => item.name === value);
    if (isValid) {
      setFilterBy(value);
      setPage(1);
    }
  };

  const searchNameOrAdviser = (value) => {
    setSearchValue((value  || '').trim());
    setPage(1);
  };

  const handleClearFilters = () => {
    setFilterBy("");
    setSearchValue("");
    setUserTypeFilter("");
    setPage(1);
  };

  const fetchExportData = async () => {
    const status = listFilter.find(item => item.name === filterBy)?.status_id || '';
    const search = searchValue || '';

    const response = await API.get(`/prospects/paginatedList?page=1&limit=${MAX_EXPORT_RECORDS}&offset=0&status=${status}&search=${search}`);
    return response.data.data;
  };

  const handleUserTypeFilter = (e) => {
    setUserTypeFilter(e.target.value);
  }

  const handleRefresh = () => {
    getListProspect(page, itemsPerPage, filterBy, searchValue);
  };

  return (
    <ListcandidateContext.Provider value={ ProviderListCandidateData }>
      <div
        className="container-fluid"
        id="applicant_container_fluid"
      >
        <div className="row mb-4">
          <Header />
        </div>
        <div className="row banner_section">
          <div className="banner_title_row">
            <span className="title_section balanz_title">{title}</span>

            {showAdminUsers && (
              <div className="users_buttons">
                <Button
                  size="md"
                  className="users_back_btn btn-warning"
                  onClick={() => history.push("/admin/users")}
                >
                  <FontAwesomeIcon
                    icon={faUsers}
                    style={{ fontSize: 16, color: "black" }}
                    className="me-2"
                  />
                  ABM Users
                </Button>

                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="users-info-tooltip">Información sobre el registro de los cambios de usuarios</Tooltip>}
                >
                  <button className="users_info_btn" onClick={() => history.push("/admin/users/audit-logs")}>
                    <FontAwesomeIcon icon={faExclamationCircle} />
                  </button>
                </OverlayTrigger>
              </div>
            )}
          </div>
        </div>
        <Filters
          changeSelectFilter={handleSelect}
          filtered={filterBy}
          searchNameOrAdviser={searchNameOrAdviser}
          appliedSearch={searchValue}
          handleRefresh={handleRefresh}
          handleClearFilters={handleClearFilters}
          isClearDisabled={!isFiltering}
          userTypeFilter={userTypeFilter}
          changeUserTypeFilter={handleUserTypeFilter}
        />

        {isFiltering && (
          <div className="active-filters">
            <span className="active-filters-label">
              Vista filtrada · {totalCount} resultado{totalCount === 1 ? '' : 's'}
            </span>
            {filterBy && (
              <span className="active-filter-chip">
                Estado: {filterBy}
                <button type="button" onClick={() => { setFilterBy(''); setPage(1); }} title="Quitar filtro de estado">×</button>
              </span>
            )}
            {searchValue && (
              <span className="active-filter-chip">
                Búsqueda: "{searchValue}"
                <button type="button" onClick={() => searchNameOrAdviser('')} title="Quitar búsqueda">×</button>
              </span>
            )}
          </div>
        )}    

        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px', margin: '1rem 0'}}>
          <button
            disabled={page === 1}
            className='btn btn-sm header_btn_logout'
            onClick={() => setPage(page - 1)}
          >
            Anterior
          </button>

          <span>Pagina {page} de {totalPages}</span>

          <select
            onChange={(e) => { setItemsPerPage(Number(e.target.value)); setPage(1); }}
            value={itemsPerPage}
            name="items_per_page"
            id="items_per_page"
            className="data_item blue_data"
          >
            <option value={20}>20 por página</option>
            <option value={50}>50 por página</option>
            <option value={100}>100 por página</option>
          </select>

          <button
            disabled={page === totalPages}
            className='btn btn-sm header_btn_logout'
            onClick={() => setPage(page + 1)}
          >
            Siguiente
          </button>
          {[ROLE.SOP_COMERCIAL, ROLE.ASISTENTE_EMBAJADOR].includes(userData?.role_id) && (
            <ExportCsvButton fetchExportData={fetchExportData} totalCount={totalCount} />
          )}
        </div>

        <div className="row container_table_candidatos" id="container_table">
          <HorizontalScroll>
            <div className="table-responsive">
              {filteredCandidateData.length > 0 ? (
                <TableCandidatesIfa />
              ) : (
                <div className="empty-results-message">
                  {isFiltering
                    ? "No se encontraron resultados con los filtros seleccionados"
                    : errorApi}
                </div>
              )}
            </div>
          </HorizontalScroll>
        </div>
      </div>
    </ListcandidateContext.Provider>
  );
};

export default Admin;
